export default __webpack_public_path__ + "resources/icons/n232-02e2.webp";